// extracted by mini-css-extract-plugin
export default {"message":"RemoveQueueItemModal-message-CHG47"};